import { disputeReason } from "@redotech/redo-dispute-db-schema/dispute-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { reclaimWinRateTimeWindow } from "./reclaim-win-rate-time-window";

/**
 * One row per (display-canonical reason, display-canonical bank) pair.
 * The handler runs `resolveReason` and `groupBankNameForDisplay` over
 * raw rows and sums collisions, so no `(reason, bankName)` pair appears
 * twice. Unknown banks surface under the literal label "Unknown"; rows
 * with no reason set surface with `reason: null`.
 *
 * Returned un-truncated — the client buckets to top-N reasons × top-N
 * banks for display.
 */
export const reclaimWinRateByReasonAndBankRowSchema = z.object({
  reason: z.enum(disputeReason).nullable(),
  bankName: z.string(),
  won: z.number().int(),
  lost: z.number().int(),
  wonExcludingProtected: z.number().int(),
  lostExcludingProtected: z.number().int(),
});

export interface ReclaimWinRateByReasonAndBankRow
  extends z.infer<typeof reclaimWinRateByReasonAndBankRowSchema> {}

export const getReclaimWinRateByReasonAndBank = unaryRpc({
  name: "getReclaimWinRateByReasonAndBank" as const,
  input: z.object({ timeWindow: z.enum(reclaimWinRateTimeWindow) }),
  output: z.object({ rows: z.array(reclaimWinRateByReasonAndBankRowSchema) }),
});
